// API bindings: data_space_participants (Auto generated)

"use strict";

import { RequestErrorHandler, RequestParams, CommonAuthenticatedErrorHandler } from "@asanrom/request-browser";
import { getApiUrl } from "./utils";
import { DataSpaceKnownParticipant, ResolvedDidDocument, AddKnownParticipantBody } from "./definitions";

export class ApiDataSpaceParticipants {
    /**
     * Method: GET
     * Path: /participants/{id}
     * Gets information for a known participant
     * @param id Participant ID
     * @returns The request parameters
     */
    public static GetKnownParticipant(id: string): RequestParams<DataSpaceKnownParticipant, GetKnownParticipantErrorHandler> {
        return {
            method: "GET",
            url: getApiUrl(`/participants/${encodeURIComponent(id)}`),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: DELETE
     * Path: /participants/{id}
     * Removes a known participant from the database
     * Requires permission: participants.admin
     * @param id Participant ID
     * @returns The request parameters
     */
    public static DeleteKnownParticipant(id: string): RequestParams<void, DeleteKnownParticipantErrorHandler> {
        return {
            method: "DELETE",
            url: getApiUrl(`/participants/${encodeURIComponent(id)}`),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(403, "*", handler.forbidden)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: GET
     * Path: /participants/{id}/did
     * Resolves DID document
     * @param id Participant DID
     * @returns The request parameters
     */
    public static ResolveDidDocument(id: string): RequestParams<ResolvedDidDocument, ResolveDidDocumentErrorHandler> {
        return {
            method: "GET",
            url: getApiUrl(`/participants/${encodeURIComponent(id)}/did`),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(400, "*", handler.badRequest)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /participants
     * Given a connector URL, figures out the participant details
     * and adds it to the list of known participants
     * Requires permission: participants.admin
     * @param body Body parameters
     * @returns The request parameters
     */
    public static AddKnownParticipant(body: AddKnownParticipantBody): RequestParams<DataSpaceKnownParticipant, AddKnownParticipantErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/participants`),
            json: body,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(400, "*", handler.badRequest)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }
}

/**
 * Error handler for GetKnownParticipant
 */
export type GetKnownParticipantErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Error handler for DeleteKnownParticipant
 */
export type DeleteKnownParticipantErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 403
     */
    forbidden: () => void;
};

/**
 * Error handler for ResolveDidDocument
 */
export type ResolveDidDocumentErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 400
     */
    badRequest: () => void;
};

/**
 * Error handler for AddKnownParticipant
 */
export type AddKnownParticipantErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 400
     */
    badRequest: () => void;

    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

